<bdo-dashboard-tile
  [tileTitle]="getTileTitle()"
  [linkData]="[{
    linkName: (bankAccountAssignments?.debit ? 'dashboard.banking.linkChangeData' : 'dashboard.banking.linkChangeType') | translate,
    href: '/daten/' + kundennummer ,
    fragment: 'banking',
    tracking: [TRACKING.LOCATION.DASHBOARD, TRACKING.ACTION.GOTO, TRACKING.LOCATION.BANKING]
  }]">
  @if (!!bankAccountAssignments && !!payments) {
    <div class="re-small">
      @if (!!payments && payments.offeneSumme && !!bankAccountAssignments) {
        <bdo-balance
          [bankAccountAssignments]="bankAccountAssignments"
          [payments]="payments"
          [kundennummer]="kundennummer"
        ></bdo-balance>
      }
      @if (!!bankAccountAssignments && !payments.offeneSumme) {
        <bdo-assignments [bankAccountAssignments]="bankAccountAssignments"
          >
        </bdo-assignments>
      }
    </div>
  }

</bdo-dashboard-tile>
